import { toast } from 'react-toastify';
import API from '../apiClient';

/**
 * @param {string} entity organization id
 * @param {{ silent?: boolean }} [options] silent: skip the "Something went wrong" toast, for
 *   best-effort lookups (e.g. the consultant organisation, which a Member may not read).
 */
export const GetOrganizationById = (entity, { silent = false } = {}) => {
    return new Promise((resolve,reject) => {
      API.get(`/organization/${encodeURIComponent(entity)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          reject(error)
          if (!silent) toast.error("Something went wrong")
          console.log(error)
        }); 
    });
  };


/**
 * Name of the consulting firm linked to an organisation record, or "" when there is none or it
 * cannot be read. Organisations created by Zavior staff point at the internal "default" org.
 */
export const resolveConsultingFirmName = async (org) => {
  let name = org?.consultant_org_name || "";
  if (!name && org?.consultant_org_id) {
    try {
      const response = await GetOrganizationById(org.consultant_org_id, { silent: true });
      name = response?.data?.organization_name || "";
    } catch (error) {
      name = "";
    }
  }
  return name.trim().toLowerCase() === "default" ? "Zavior" : name;
};
